import { Stack, Typography, useTheme } from "@mui/material";
import { Check, ChevronRight, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { PaperworkDocTone } from "web_myplann/Profile/Constants/paperworkDocTypes";
import { getPaperworkToneColors } from "web_myplann/Profile/Helpers/paperworkToneColors";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	tone: PaperworkDocTone;
	name: string;
	selected?: boolean;
	onClick?: () => void;
};

export const PaperworkTypeRow: FC<Props> = ({
	icon: Icon,
	tone,
	name,
	selected = false,
	onClick,
}) => {
	const { palette } = useTheme();

	const toneColors = getPaperworkToneColors(palette, tone);

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			onClick={onClick}
			bgcolor={selected ? palette.blue[50] : undefined}
			sx={{
				cursor: onClick ? "pointer" : "default",
				"&:active": onClick
					? { bgcolor: selected ? palette.blue[100] : palette.grey[50] }
					: undefined,
			}}
		>
			<IconBox bg={toneColors.bg} size={40}>
				<Icon size={20} color={toneColors.color} />
			</IconBox>
			<Typography
				variant={selected ? "bodyStrong" : "body2"}
				color={selected ? palette.blue[700] : palette.grey[900]}
				flex={1}
			>
				{name}
			</Typography>
			{selected ? (
				<Check size={20} color={palette.blue[600]} />
			) : (
				<ChevronRight size={20} color={palette.grey[300]} />
			)}
		</Stack>
	);
};
